import React from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft, FaExclamationCircle } from "react-icons/fa";
import { Logout } from "@mui/icons-material";
import { motion } from "framer-motion";
import useAuth from "../../useAuth";

export default function UnAuthorized() {
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-indigo-200 via-white to-primary/30 px-4">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="bg-white rounded-3xl shadow-2xl p-10 max-w-lg w-full text-center"
      >
        {/* Icon */}
        <motion.div
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 0.2 }}
          className="flex justify-center mb-6"
        >
          <div className="bg-red-100 border-8 border-red-400 text-red-600 rounded-full p-5 shadow-inner">
            <FaExclamationCircle className="text-5xl" />
          </div>
        </motion.div>

        {/* Headings */}
        <motion.h1
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3 }}
          className="text-4xl font-extrabold text-primary mb-2"
        >
          Access Denied
        </motion.h1>
        <p className="text-base text-gray-600 mb-4">
          Oops! You don’t have permission to view this page.
        </p>

        {/* Error Code */}
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4 }}
          className="text-6xl font-bold text-red-500 mb-8"
        >
          403
        </motion.p>

        {/* Buttons */}
        <div className="flex flex-col sm:flex-row justify-center gap-4 mb-6">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 px-6 py-2 rounded-full border border-primary text-primary hover:bg-primary hover:text-white transition duration-200"
          >
            <FaArrowLeft className="text-sm" />
            Go Back
          </button>
          <button
            onClick={() => {
              localStorage.clear();
              navigate("/login");
              window.location.reload();
            }}
            className="flex items-center gap-2 px-6 py-2 rounded-full bg-red-500 text-white hover:bg-red-600 transition duration-200"
          >
            <Logout fontSize="small" />
            Logout
          </button>
        </div>

        {/* Help Text */}
        <p className="text-sm text-gray-400">
          If you need assistance, please{" "}
          <a
            href="mailto:support@yourwebsite.com"
            className="text-blue-600 hover:underline"
          >
            contact support
          </a>{" "}
          or visit our{" "}
          <a href="/help" className="text-blue-600 hover:underline">
            Help Center
          </a>
          .
        </p>
      </motion.div>
    </div>
  );
}
